import {
  Button,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  usePopoverContext,
} from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { ReactNode } from 'react';

import { FilterActionButtons, FilterActionButtonsProps } from './FilterActionButtons';

type Props = {
  label: string;
};

export const FilterPopoverButton = ({ label }: Props) => {
  return (
    <PopoverTrigger>
      <Button size="sm">{label}</Button>
    </PopoverTrigger>
  );
};

type FilterPopoverContentProps = FilterActionButtonsProps & {
  header?: string;
  children?: ReactNode;
};

export const FilterPopoverContent = ({ header, children, onClickCancel, onClickApply }: FilterPopoverContentProps) => {
  const { onClose } = usePopoverContext();

  return (
    <PopoverContent _focus={{ shadow: 'none', outline: 0 }} _focusVisible={{ shadow: 'outline' }}>
      <Show if={!!header}>
        <PopoverHeader srOnly>{header}</PopoverHeader>
      </Show>
      <PopoverBody padding="2">{children}</PopoverBody>
      <PopoverFooter>
        <FilterActionButtons
          onClickCancel={() => {
            onClickCancel?.();
            onClose();
          }}
          onClickApply={() => {
            onClickApply?.();
            onClose();
          }}
        />
      </PopoverFooter>
    </PopoverContent>
  );
};
